import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import qs from 'qs';
import { Proposition, ServiceBlockFilter } from 'src/types';

export const servicePropositionsApiUrl = '/ServicePropositions';
export const serviceApiUrl = '/Services';
export const serviceCategoriesApiUrl = '/Services/categories';
export const serviceCategoryApiUrl = '/Services/category';
export const serviceTagsApiUrl = `${serviceApiUrl}/tags`;

const ApiUrls = {
  serviceApiUrl,
  serviceCategoriesApiUrl,
  servicePropositionsApiUrl,
  serviceTagsApiUrl
};

const PostServicePropositionRequest = (data: Proposition) => nzApiAxios.post(servicePropositionsApiUrl, data);

const GetServicesCategories = () => nzApiAxios.get(serviceCategoriesApiUrl).then((response) => response.data);

const GetCategoriesTags = () => nzApiAxios.get(serviceApiUrl + '/allTags').then((response) => response.data);

const GetServicesCategoryByName = (params: { name?: string; slug?: string }) =>
  nzApiAxios.get(serviceCategoryApiUrl, { params }).then((response) => response.data);

function GetServicesTags(query: Partial<ServiceBlockFilter>) {
  return nzApiAxios
    .get(serviceTagsApiUrl, {
      params: query,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((response) => response.data);
}

function GetServicesBlocksRequest(query: Partial<ServiceBlockFilter>, page = 1) {
  return nzApiAxios
    .get(serviceApiUrl, {
      params: { ...query, page },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((value) => value.data);
}

function GetStartPageServices(query: Partial<ServiceBlockFilter>, page = 1) {
  return nzApiAxios
    .get(serviceApiUrl + '/start-page', {
      params: { ...query, page },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((value) => value.data);
}

const API = {
  proposeService: PostServicePropositionRequest,
  getServicesBlocks: GetServicesBlocksRequest,
  getCategories: GetServicesCategories,
  getCategoryByName: GetServicesCategoryByName,
  getTags: GetServicesTags,
  getCategoryTags: GetCategoriesTags,
  getStartPageServices: GetStartPageServices
};

export { ApiUrls };
export default API;
